import { useGetApiDataAsMutate } from "shared/datalayer";
import { ApiApplicableRateCardDetails } from "shared/types/ApiApplicableRateCardDetails";
import MyExpApi from "../../enum/MyExpApi";

export function useValidateInventoryCouponCode(apiUrl: MyExpApi) {
  return useGetApiDataAsMutate<ApiApplicableRateCardDetails>(apiUrl);
}
